import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';

import { Center, Spinner } from 'quotient';

import { JobsAggregationContextProvider } from 'components/TQModels/context/JobsAggregationContext';
import {
  ROUTE_PLANNING_CYCLES,
  ROUTE_PLANNING_CYCLES_APPROVALS,
  ROUTE_PLANNING_CYCLES_WORKFLOWS,
  ROUTE_SPM_MODEL_SUDO,
  ROUTE_SPM_PLAN_APPROVAL,
  ROUTE_SPM_PLAN_DETAIL_VIEW,
  ROUTE_SPM_PLAN_VIEW,
  SPM_URL_PREFIX,
  TQ_URL_PREFIX,
} from 'constants/routes';

const Home = lazy(() => import('components/Home/Home'));
const NotFound = lazy(() => import('components/NotFound/NotFound'));
const PlanningCyclesView = lazy(() => import('components/PlanningCycles/PlanningCyclesView'));
const PlanDetailView = lazy(() => import('components/SPM/PlanDetailView/PlanDetailView'));
const SPMModelView = lazy(() => import('components/SPM/SPMModels/SPMModelViewLegacy'));
const SPMModelSuperAdminView = lazy(() => import('components/SPM/SPMModels/SPMModelSuperAdminView'));

export const TQRouter: React.FC = () => {
  return (
    <Suspense
      fallback={
        <Center h="100vh">
          <Spinner />
        </Center>
      }
    >
      <JobsAggregationContextProvider>
        <Routes>
          {/* TQ Routes */}
          <Route element={<Home />} path={`${TQ_URL_PREFIX}/`} />
          <Route element={<PlanningCyclesView />} path={`${ROUTE_PLANNING_CYCLES_WORKFLOWS}/*`} />
          <Route element={<PlanningCyclesView />} path={`${ROUTE_PLANNING_CYCLES_APPROVALS}/*`} />
          <Route element={<PlanningCyclesView />} path={ROUTE_PLANNING_CYCLES} />
          <Route element={<PlanDetailView />} path={`${TQ_URL_PREFIX}/planning_cycles/:planningCycleId`} />

          {/* SPM Routes */}
          <Route
            element={<SPMModelView />}
            path={`${TQ_URL_PREFIX}/planning_cycles/:planningCycleId${SPM_URL_PREFIX}/:spmModelId`}
          />
          <Route element={<SPMModelSuperAdminView />} path={`${ROUTE_SPM_MODEL_SUDO}/*`} />

          {/* Unified SPM View Entry Point Routes */}
          <Route element={<PlanDetailView />} path={`${ROUTE_SPM_PLAN_APPROVAL}/*`} />
          <Route element={<PlanDetailView />} path={`${ROUTE_SPM_PLAN_DETAIL_VIEW}/*`} />
          <Route element={<PlanDetailView />} path={`${ROUTE_SPM_PLAN_VIEW}/*`} />

          <Route element={<NotFound />} path="*" />
        </Routes>
      </JobsAggregationContextProvider>
    </Suspense>
  );
};
